export default __webpack_public_path__ + "static/media/pediclescrew_demo_image.0123c5f3.jpg";